import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import parse from "html-react-parser";
import type { Product } from "@/interfaces/product";
import { normalizeDescriptionHtml } from "@/utils/html-text-helper";

// The global `* { margin: 0 }` reset leaves description paragraphs touching (GFG-339).
export const DETAILS_BODY_SX = {
  fontSize: "14px",
  lineHeight: "24px",
  color: "var(--color-rodeo-black)",
  "& p": { m: 0, mb: 1.5 },
  "& p:last-child": { mb: 0 },
  // A paragraph right after a list gets the same 12px gap: lists have no margin, and
  // normalizeDescriptionHtml drops the bare <br> between them. Two keys, never one comma list:
  // under <StyledEngineProvider enableCssLayer> (src/index.tsx) Emotion drops comma selectors
  // that use a combinator (same trap as components/admin/contacts/RedemptionLinkCell.tsx).
  "& ul + p": { mt: 1.5 },
  "& ol + p": { mt: 1.5 },
} as const;

export default function DetailsPanel({ product }: { product: Product }) {
  const description = product.detailsDescription;
  const bullets = product.bulletPoints ?? product.impactTiles.map((t) => t.description);

  return (
    <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Typography component="div" sx={DETAILS_BODY_SX}>
        {parse(normalizeDescriptionHtml(description))}
      </Typography>
      <Box component="ul" sx={{ m: 0, p: 0, listStyle: "none" }}>
        {bullets.map((bullet) => (
          <Typography
            key={bullet}
            component="li"
            sx={{
              fontSize: "14px",
              lineHeight: "24px",
              color: "var(--color-rodeo-black)",
            }}
          >
            • {bullet}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
